import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestsDeleteRes extends EntityRequest {
  public message: string | null = null;
}
